import api from './api';

export const getOsById = async (osId: any) => {
  return await api.get(`/os/${osId}`);
};

export const getOsFromUser = async () => {
  const user: any = localStorage.getItem('user');
  const { id } = JSON.parse(user);
  return await api.get(`/os?prestador=${id}`);
};

export const newOs = async (os: any) => {
  return await api.post('/os', os);
};

export const getOsMonthly = () => {
  const user: any = localStorage.getItem('user');
  const { id } = JSON.parse(user);
  
  // console.log('Buscando OSs por mês para o prestador: ', id);
  
  return api.get(`/os/mensal?prestador=${id}`);
};

export const getOsAVGRes = (year?:number, month?:number) => {
  const user: any = localStorage.getItem('user');
  const { id } = JSON.parse(user);

  if (month && year) {
    return api.get(`/os/avg-res?prestador=${id}&mes=${month}&ano=${year}`);
  } else {
    return api.get(`/os/avg-res?prestador=${id}`);
  }
};

export const getOsAVGGrade = () => {
  const user: any = localStorage.getItem('user');
  const { id } = JSON.parse(user);
  return api.get(`/os/avg-grade?prestador=${id}`);
};

export const updateOs = (os: any) => {
  return api.put(`/os/${os?.id}`, os);
};

export const deleteOs = (idOS: string) => {
  return api.delete(`/os/${idOS}`);
};

export const getOsFromUserPerPage = (currentPageIndex: any) => {
  const user: any = localStorage.getItem('user');
  const { id } = JSON.parse(user);
  return api.get(`/os/os?prestador=${id}&${currentPageIndex}}`);
};
